import { post } from "../base.ehq.model";
import { serialize } from "./user-availability.serializer";
import { deserialize } from "../base.serializer";

export const verifyUserAvailability = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/register/user_availability`;
    const serializedBody = serialize(body);

    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
